import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function AlignLeftIcon(props: IconProps): ReactElement {
  const { width = 24, height = 24, className = "" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.4001 4.8001C20.4001 5.46274 19.8627 6.0001 19.2001 6.0001H4.8001C4.13746 6.0001 3.6001 5.46274 3.6001 4.8001C3.6001 4.13746 4.13746 3.6001 4.8001 3.6001H19.2001C19.8627 3.6001 20.4001 4.13746 20.4001 4.8001ZM12.0001 8.4001H4.8001C4.13746 8.4001 3.6001 8.93746 3.6001 9.6001C3.6001 10.2627 4.13746 10.8001 4.8001 10.8001H12.0001C12.6627 10.8001 13.2001 10.2627 13.2001 9.6001C13.2001 8.93746 12.6627 8.4001 12.0001 8.4001ZM19.2001 13.2001H4.8001C4.13746 13.2001 3.6001 13.7375 3.6001 14.4001C3.6001 15.0627 4.13746 15.6001 4.8001 15.6001H19.2001C19.8627 15.6001 20.4001 15.0627 20.4001 14.4001C20.4001 13.7375 19.8627 13.2001 19.2001 13.2001ZM12.0001 18.0001H4.8001C4.13746 18.0001 3.6001 18.5375 3.6001 19.2001C3.6001 19.8627 4.13746 20.4001 4.8001 20.4001H12.0001C12.6627 20.4001 13.2001 19.8627 13.2001 19.2001C13.2001 18.5375 12.6627 18.0001 12.0001 18.0001Z"
        fill="#A1A1A1"
      />
    </svg>
  );
}
